exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".review-users-container{margin:8px 0;padding:13px;padding-left:16px;border-top:1px solid #ababab;border-bottom:1px solid #ababab}.review-users-container hr{margin:0}.review-users-container .members{margin-bottom:5px;font-weight:700}.review-users-container .members:first-of-type{margin-top:5px}.review-users-container .members span{font-weight:initial;padding-left:10px}\n", ""]);

// exports
